// eslint-disable-next-line import/no-amd
define([
    '../../../utils/Globals',
    'jquery',
    'underscore',
    '../../app/models/MabinsoModel'
], (Globals, $, _, MabinsoModel) => {
    const ProtocolModel = MabinsoModel.extend({
        urlRoot: Globals.baseUrl + 'protocols/protocol',
        defaults: {
        },
        initialize() {
        },
        validate() {
        },
        getAParameter(count) {
            const model = this;
            if (_.isUndefined(model.get('sParameter'))) {
                if (_.isUndefined(model.get('parameter')) || model.get('parameter') == null) {
                    return null;
                }
                const splited2 = model.get('parameter').split(';');
                model.set('sParameter', splited2);
            }
            const splited = model.get('sParameter');
            if (_.isUndefined(splited[count])) {
                return null;
            }
            return splited[count];
        }
    });
    return ProtocolModel;
});



// WEBPACK FOOTER //
// ./src/components/protocol/models/ProtocolModel.js